<template>
  <div   class="animated fadeIn">
      <Alerts ref="alert"/>
      <b-tabs>
        <b-tab :title="$lang.CarInspection.General.Search" active>
          <template slot="title">
            <i class="fa fa-search text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.CarInspection.General.Search }}</span>
          </template>
          <ExpertRoutesSearch ref="Search" />
        </b-tab>
        <!--
        <b-tab :title="'Mapa'">
          <template slot="title">
            <i class="fa fa-map-marker text-third"></i><span class="d-md-down-none pl-1 text-third">Mapa</span>
          </template>
          <div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d116991.02860199857!2d-46.6753232140285!3d-23.60542160993107!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce448183a461d1%3A0x9ba94b08ff335bae!2zU8OjbyBQYXVsbywgU1A!5e0!3m2!1spt-BR!2sbr!4v1594907961689!5m2!1spt-BR!2sbr" width="100%" height="700" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
          </div>
        </b-tab>
        -->
      </b-tabs>
  </div>
</template>

<script>
import Alerts from '@/components/forms/Alerts'
import ExpertRoutesSearch from './search/expertroutessearch.vue'

export default {
  name: 'ExpertRoutes',
  data () {
    return {
    }
  },
  components: {
    Alerts,
    ExpertRoutesSearch
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/expertroutes/expertroutes.vue